import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId: "zp4otiet",
  dataset: "production",
  apiVersion: "2023-05-03",
  // CDN reads are fast but can lag a short while after a publish; reading
  // live keeps new/edited posts showing up immediately on refresh.
  useCdn: false,
});

const builder = imageUrlBuilder(sanityClient);

export const urlForImage = (source) => builder.image(source);
